import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SelectField = (props: any) => {
  const { infoText, ...restProps } = props;
  const getInfoText = () => {
    if (typeof infoText === "string") return infoText;
    if (infoText === true) {
      return "Field Type: Dropdown, Selection required";
    }
    return "";
  };

  const finalInfoText = getInfoText();

  return (
    <>
      <div className="form-floating position-relative">
        <select className="form-select" {...restProps}>
          {props?.children}
        </select>
        <label htmlFor={props.id || "floatingSelect"}>
          {props?.placeholder}
          {finalInfoText && !props.disabled && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={`tooltip-${props.name}`}>{finalInfoText}</Tooltip>}
            >
              <a className="ms-1 align-self-center">
                <img className=" pe-auto" 
                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
              </a>
            </OverlayTrigger>
          )}
        </label>
      </div>
    </>
  );
};

export default SelectField;
